import styled from 'react-emotion';
import { colors } from '@ublend-npm/aulaui-next-web/themes/default';

export const Container = styled('div')`
  display: flex;
  flex: 1;
  height: 100%;
  flex-direction: column;
  align-items: center;
  background-color: ${colors.grey12};
  padding-top: 80px;
`;

export const Title = styled('div')`
  font-size: 20px;
  line-height: 24px;
  font-weight: 500;
  color: ${colors.text};
  padding-top: 34px;
`;

export const Text = styled('div')`
  width: 383px;
  font-size: 14px;
  line-height: 20px;
  color: ${colors.text};
  padding-top: 12px;
`;
